var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-expand-wrapper",class:{
  'query-wrapper__show': _vm.show
}},[_vm._t("default"),_c('el-divider')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }